// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import {
  createCompanyLicence,
  createFacebase,
  uploadLicencefile
} from "../../actions/companyActions";
import { updateLicence } from "../../../admin/actions/licenceAdminActions";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import CreateLicenceForm from "../../components/licences/CreateLicenceForm";

type CreateLicenceFormReduxPropsType = {
  licence: { [key: string]: * },
  facebases: Array<*>,
  company: { [key: string]: * },
  isEdit?: boolean,
  isAdmin?: boolean,
  displayCompany?: boolean,
  onClose: Function,
  openSnackbar: Function,
  currentUser: { [key: string]: * },
  actions: {
    createCompanyLicence: Function,
    createFacebase: Function,
    uploadLicencefile: Function,
    updateLicence: Function
  }
};

class CreateLicenceFormRedux extends Component<
  CreateLicenceFormReduxPropsType,
  *
> {
  createLicence = (
    isNewSystem: boolean,
    facebase_id: string,
    facebase_name: string,
    person_limit: number,
    online: boolean,
    type: string,
    years: number,
    days: number,
    auto_assign: boolean,
    start_date: Date,
    expiry_date: Date,
    device_count: number,
    camera_count: number,
    po_file: File,
    model: string,
    modules: Array<*>,
    doneCall: Function,
    failCall: Function
  ): * => {
    const uploadFileCall = (licence: *): * => {
      this.props.actions.uploadLicencefile(
        this.props.company.id,
        licence.id,
        po_file,
        doneCall,
        failCall,
        this.props.isAdmin ? "admin" : "company"
      );
    };

    const createLicenceCall = (doneCall: Function, facebaseId: string): * => {
      this.props.actions.createCompanyLicence(
        type,
        camera_count,
        this.props.company.id,
        device_count,
        expiry_date,
        auto_assign,
        start_date,
        facebaseId,
        modules,
        doneCall,
        failCall,
        this.props.isAdmin
      );
    };

    if (isNewSystem) {
      this.props.actions.createFacebase(
        person_limit,
        online,
        facebase_name,
        this.props.company.id,
        (facebase: *) => {
          if (po_file) {
            createLicenceCall((licence: *) => {
              uploadFileCall(licence);
            }, facebase.id);
          } else {
            createLicenceCall(doneCall, facebase.id);
          }
        },
        failCall,
        model,
        this.props.isAdmin
      );
    } else {
      if (po_file) {
        createLicenceCall((licence: *) => {
          uploadFileCall(licence);
        }, facebase_id);
      } else {
        createLicenceCall(doneCall, facebase_id);
      }
    }
  };

  updateLicence = (
    licenceId: string,
    expiry_date: Date,
    start_date: Date,
    additional_slot: number,
    auto_assign: boolean,
    licence_type: string,
    camera_count: number,
    face_count: number,
    po_file: File,
    modules: Array<*>,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.updateLicence(
      licenceId,
      expiry_date,
      start_date,
      additional_slot,
      auto_assign,
      licence_type,
      camera_count,
      face_count,
      modules,
      po_file
        ? this.props.actions.uploadLicencefile(
          this.props.company.id,
          licenceId,
          po_file,
          doneCallback,
          failCallBack,
          this.props.isAdmin
            ? this.props.displayCompany
              ? "adminLicence"
              : "adminCompany"
            : "company"
        )
        : doneCallback,
      failCallBack,
      this.props.company.id,
      this.props.isAdmin
        ? this.props.displayCompany
          ? "adminLicence"
          : "adminCompany"
        : "company"
    );
  };

  render(): React$Element<*> {
    const isImagusAdmin = hasPrincipal(
      "evaluation_licence_admin",
      this.props.currentUser.groups
    );
    const isLicenceAdmin = hasPrincipal(
      "licence_delegater",
      this.props.currentUser.groups
    );
    const canChangeModel = hasPrincipal(
      "imagus_admin",
      this.props.currentUser.groups
    );
    const currentCompanyType = this.props.currentUser.company.companyType;

    let LicenceTypes = [];
    //remove hasLicenceDelegator when licence api is migrated
    const hasLicenceDelegatorOnly = isLicenceAdmin && !canChangeModel;

    if (!hasLicenceDelegatorOnly) {
      if (this.props.company.level === "E" && isLicenceAdmin) {
        LicenceTypes.push({
          value: "LONGTERM",
          label: "Standard Licence(with 1 year maintenance)"
        });
        LicenceTypes.push({
          value: "SHORTTERM",
          label: "Short Term Licence"
        });
      }
      // if (this.props.isEdit && this.props.licence) {
      //   if (this.props.licence.authorisedReseller) {
      //     LicenceTypes.push({
      //       value: "LONGTERM",
      //       label: "Authorised Licence (with 1 year maintenance)"
      //     });
      //     LicenceTypes.push({
      //       value: "SHORTTERM",
      //       label: "Short Term Licence"
      //     });
      //   } else {
      //     LicenceTypes.push({
      //       value: "LONGTERM",
      //       label: "Standard Licence(with 1 year maintenance)"
      //     });
      //     LicenceTypes.push({
      //       value: "SHORTTERM",
      //       label: "Short Term Licence"
      //     });
      //   }
      // } else {
      //   if (this.props.company.authorised === 1) {
      //     LicenceTypes.push({
      //       value: "LONGTERM",
      //       label: "Authorised Licence (with 1 year maintenance)"
      //     });
      //     LicenceTypes.push({
      //       value: "SHORTTERM",
      //       label: "Short Term Licence"
      //     });
      //   } else {
      //     LicenceTypes.push({
      //       value: "LONGTERM",
      //       label: "Standard Licence(with 1 year maintenance)"
      //     });
      //     LicenceTypes.push({
      //       value: "SHORTTERM",
      //       label: "Short Term Licence"
      //     });
      //   }
      // }
    }
    if (
      currentCompanyType === "TOPLEVEL" ||
      currentCompanyType === "DISTRIBUTER"
    ) {
      if (this.props.company.licenceLimit !== "LD") {
        LicenceTypes.push({ value: "DEMO", label: "Demo Licence" });
      }
    } else if (currentCompanyType === "RESELLER") {
      if (this.props.company.level === "E") {
        LicenceTypes.push({ value: "DEMO", label: "Demo Licence" });
      }
    }
    if (isImagusAdmin) {
      LicenceTypes.push({ value: "EVALUATION", label: "Evaluation Licence" });
      LicenceTypes.push({ value: "ONEYEAR", label: "One Year Licence" });
    }

    let facebaseList = [];
    if (this.props.facebases.length > 0) {
      facebaseList = this.props.facebases.map((facebase: *): * => ({
        value: facebase.node.id,
        label: facebase.node.name,
        personLimit: facebase.node.personLimit
      }));
    }

    const modelList = [
      { value: 16, label: "V2 (16)" },
      { value: 4, label: "V1 (4)" }
    ];

    return (
      <CreateLicenceForm
        licence={this.props.licence}
        facebases={facebaseList}
        isEdit={this.props.isEdit}
        onClose={this.props.onClose}
        openSnackbar={this.props.openSnackbar}
        LicenceTypes={LicenceTypes}
        createLicence={this.createLicence}
        updateLicence={this.updateLicence}
        canChangeModel={canChangeModel}
        modelList={modelList}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  currentUser: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { createCompanyLicence, createFacebase, uploadLicencefile, updateLicence },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateLicenceFormRedux);
